import { render, staticRenderFns } from "./EditRental.vue?vue&type=template&id=60b6cc94&scoped=true&"
import script from "./EditRental.vue?vue&type=script&lang=js&"
export * from "./EditRental.vue?vue&type=script&lang=js&"
import style0 from "./EditRental.vue?vue&type=style&index=0&id=60b6cc94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b6cc94",
  null
  
)

export default component.exports